var TabEquipmentsModule = /** @class */ (function () {
    function TabEquipmentsModule() {
    }
    return TabEquipmentsModule;
}());
export { TabEquipmentsModule };
